import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import uuid from '@cotyorg/ccx-utils/js/helpers/uuid';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';

const ProductSteps = ({ productSteps }) => (
  <div className="product-steps__copy-box">
    {Array.isArray(R.prop('steps', productSteps)) &&
      R.prop('steps', productSteps).map(({ heading, description }) => (
        <div key={uuid()} className="product-steps__item">
          <Heading level={5} extraClass="product-steps__step-heading">
            {heading}
          </Heading>
          <Paragraph extraClass="product-steps__step-paragraph">
            {description}
          </Paragraph>
        </div>
      ))}
  </div>
);

ProductSteps.propTypes = {
  productSteps: PropTypes.shape({
    imageSrc: PropTypes.string,
    imageSrcSet: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        src: PropTypes.string,
      })
    ),
  }),
};

export default ProductSteps;
